import styled from 'styled-components';

export const SIcon = styled.p`
  && {
    height: 15px;
    width: 13px;
    svg {
      height: 15px;
      width: 13px;
      margin-bottom: 4px;
    }
    path {
      fill: ${({theme}) => theme.palette.colors.gray400};
    }
  }
`;

export const SDot = styled.p`
  && {
    height: 3px;
    width: 3px;
    background-color: ${({theme}) => theme.palette.colors.gray300};
    border-radius: 50%;
  }
`;
